import { HTMLAttributes, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { useElementShown } from '@hh.ru/analytics-js';
import itemShown from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/hhpro_advantage_element_shown';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Title, VSpacing, Text, useBreakpoint, TitleProps } from '@hh.ru/magritte-ui';

import styles from './styles.less';

const TrlKeys = {
    about1: {
        title: 'hhpro.promo.about1.title',
        description: 'hhpro.promo.about1.description',
    },
    about2: {
        title: 'hhpro.promo.about2.title',
        description: 'hhpro.promo.about2.description',
    },
    about3: {
        title: 'hhpro.promo.about3.title',
        description: 'hhpro.promo.about3.description',
    },
};

interface ItemProps {
    blockNumber: 1 | 2 | 3;
    tariffId: string;
    Wrapper: React.FC<PropsWithChildren<HTMLAttributes<HTMLDivElement>>>;
}

const Item: TranslatedComponent<ItemProps> = ({ Wrapper, blockNumber, tariffId, trls }) => {
    const breakpoint = useBreakpoint();
    let titleSize: TitleProps['size'] = 'small';
    if (breakpoint.isM) {
        titleSize = 'medium';
    } else if (breakpoint.isGtM) {
        titleSize = 'large';
    }

    const ref = useElementShown((element: HTMLElement) => itemShown(element, { blockNumber, tariffId }));

    const key = `about${blockNumber}` as const;
    return (
        <Wrapper className={styles.sliderItem}>
            <div ref={ref} className={classNames(styles.aboutContainer, styles[`abountContainer${blockNumber}`])}>
                <Title style="contrast" Element="h4" size={titleSize}>
                    <span className={styles.titleSize}>{trls[TrlKeys[key].title]}</span>
                </Title>
                <VSpacing default={16} gteM={40} />
                <div className={styles.aboutContent}>
                    <Text
                        typography={breakpoint.isGtS ? 'paragraph-1-regular' : 'paragraph-3-regular'}
                        style="contrast"
                    >
                        {trls[TrlKeys[key].description]}
                    </Text>
                </div>
            </div>
        </Wrapper>
    );
};

export default translation(Item);
